import React from 'react';
import clone from 'clone';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OELicensingAccessProvider from '../../../react-oe/oe-licensing-access-provider';
import {OEFeature} from '../../../react-oe/oe-types';
import OEModelStateUpdateEnabledStateDriver from '../../../react-oe/oe-model-state-update-enabled-state-driver';
import {withUILevel} from '../../../lib/react/oe-higher-order-components';
import retardUpdate from '../../../lib/react/update-retarder';
import {UILevel} from '../../../lib/oe-types';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import OEButton from '../../elements/controls/oe-button';
import OEDropdown from '../../elements/controls/oe-dropdown';
import OEMultiColumnContainer from '../../elements/oe-multi-column-container';
import {OEColorPickerNumericInputType} from '../../color-picker/oe-color-picker';
import {OEGroupControl, OEControl, OESliderControl, OEToggleCheckboxControl, OEColorPickerButtonControl} from '../../elements/controls/oe-controls';
import {OESettingsControlGroupType, OESettingsControlType, OESettingsControllerProps} from './oe-settings-model';
import OEVPGizmoControllerControlPanel from '../vp-gizmo/oe-vp-gizmo-controller-control-panel';

export class OESettingsController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.groups = this.createGroups();

        this.state = {
            uiEnabled:                              false,
            groups:                                 clone(this.groups),
            language:                               0,
            switchPrimarySecondaryLanguage:         false,
            brightness:                             0.5,
            bgColor:                                {x: 0, y: 0, z: 0},
            defaultBGColor:                         {x: 0, y: 0, z: 0},
            touchSensitivity:                       0.5,
            ambientOcclusion:                       false,
            maxAOQuality:                           0,
            rendererPresets:                        [],
            activeRendererPreset:                   '',
            uiLevel:                                UILevel.std,
            compHighlightingVP:                     true,
            compHighlightingVPColor:                {x: 0, y: 1, z: 0, w: 1},
            compHighlightingLabels:                 true,
            availableLanguages:                     [0, 1],
            tutorUIEnabled:                         false,
            tutorIsClear:                           true,
            vpGizmoDeactivated:                     false,
            strings:   {
                backgroundCategory:                 '',
                devCategory:                        '',
                languageCategory:                   '',
                graphicsSettingsCategory:           '',
                touchSensitivityCategory:           '',
                tutorCategory:                      '',
                uiCategory:                         '',
                vpGizmoCategory:                    '',
                languageListBtn:                    '',
                languageSwitchLabel:                '',
                brightnessSliderLabel:              '',
                bgColorButtonLabel:                 '',
                ambientOcclusionSwitchLabel:        '',
                rendererPresetLabel:                '',
                languages: {
                    lang_0:                         'English',
                    lang_1:                         'German',
                    lang_2:                         'Chinese',
                    lang_3:                         'Italian',
                    lang_4:                         'Dutch',
                    lang_5:                         'Korean',
                    lang_6:                         'Japanese',
                    lang_7:                         'Finnish',
                    lang_8:                         'Portugese',
                    lang_9:                         'Swedish'
                },
                uiLevelLabel:                       '',
                uiLevels: {
                    std:                            '',
                    simple:                         '',
                    advanced:                       ''
                },
                showComponentIDsLabel:              '',
                compHighlightingVPSwitchLabel:      '',
                compHighlightingVPColorBtnLabel:    '',
                compHighlightingLabelSwitchLabel:   '',
                tutorReset:                         ''
            },
            featureAccess: {
                tooltip:                            false,
                highlight:                          false
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.updateControlsState = this.updateControlsState.bind(this);
        this.updateTutorState = this.updateTutorState.bind(this);
        this.updateVPGizmoState = this.updateVPGizmoState.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
        this.onFeatureAccessChanged = this.onFeatureAccessChanged.bind(this);

        this.onLicensingAccess = this.onLicensingAccess.bind(this);

        this.onModelStateUpdateDriverRef = this.onModelStateUpdateDriverRef.bind(this);

        this.onLanguageSelected = this.onLanguageSelected.bind(this);
        this.onLanguageSwitchChanged = this.onLanguageSwitchChanged.bind(this);
        this.onBrightnessSliderStart = this.onBrightnessSliderStart.bind(this);
        this.onBrightnessSliderEnd = this.onBrightnessSliderEnd.bind(this);
        this.onBrightnessSliderChanged = this.onBrightnessSliderChanged.bind(this);
        this.onBackgroundColorPickerShow = this.onBackgroundColorPickerShow.bind(this);
        this.onBackgroundColorPickerHide = this.onBackgroundColorPickerHide.bind(this);
        this.onBackgroundColorPickerChange = this.onBackgroundColorPickerChange.bind(this);
        this.onTouchSensitivitySliderChanged = this.onTouchSensitivitySliderChanged.bind(this);
        this.onAmbientOcclusionSwitchChanged = this.onAmbientOcclusionSwitchChanged.bind(this);
        this.onPresetSelected = this.onPresetSelected.bind(this);
        this.onUILevelSelected = this.onUILevelSelected.bind(this);
        this.onShowComponentIDsSwitchChanged = this.onShowComponentIDsSwitchChanged.bind(this);
        this.onCompHighlightingVPSwitchChanged = this.onCompHighlightingVPSwitchChanged.bind(this);
        this.onHighlightingVPColorBtnChanged = this.onHighlightingVPColorBtnChanged.bind(this);
        this.onCompHighlightingLabelsSwitchChanged = this.onCompHighlightingLabelsSwitchChanged.bind(this);
        this.onTutorResetBtnPressed = this.onTutorResetBtnPressed.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(!OEToolbox.shallowEqual(nextProps.config.controls, this.props.config.controls, true))  {
            this.updateGroups(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.settingsVignetteStrengthChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.settingsBGColorChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.touchSensitivityChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.renderQualityConfigChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.rendererPresetChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiLevelChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.showComponentIDsChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.compHighlightingVPChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.compHighlightingVPColorChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.compHighlightingLabelsChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.tutorIsClearStateChanged, this.updateTutorState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.vpGizmoDeactivatedChanged, this.updateVPGizmoState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.settingsVignetteStrengthChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.settingsBGColorChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.touchSensitivityChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.renderQualityConfigChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.rendererPresetChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiLevelChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.showComponentIDsChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.compHighlightingVPChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.compHighlightingVPColorChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.compHighlightingLabelsChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.tutorIsClearStateChanged, this.updateTutorState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.vpGizmoDeactivatedChanged, this.updateVPGizmoState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
    }

    isMasked(entry) {
        if(!entry.mask) return false;
        const mask = entry.mask;
        if(mask.masked)   return true;

        const licenseValid = !this.licensingAccess.isLicensing || this.licensingAccess.isValid;

        if(mask.licensingAccess && !mask.licensingAccess(this, entry, this.licensingAccess, this.oe))    return true;

        if(typeof(mask.licenseValid) === 'boolean' && mask.licenseValid !== licenseValid)   return true;

        return false;
    }

    createGroups(props) {
        props = props || this.props;

        if(!Array.isArray(props.config.controls))   return [];

        let groups = [];

        for(let i = 0; i < props.config.controls.length; ++i) {
            let controlGroup = props.config.controls[i];
            if(!controlGroup)  continue;

            let {controls: controlGroupControls, ...rest} = controlGroup;

            let group = {
                type:       controlGroup.type,
                masked:     this.isMasked(rest),
                proto:      clone(rest),
                controls:   []
            };

            if(Array.isArray(controlGroupControls))    {
                for(let j = 0; j < controlGroupControls.length; ++j)   {
                    let control = controlGroupControls[j];
                    if(!control)  continue;

                    let control_ = {
                        type:       control.type,
                        enabled:    control.enabled,
                        masked:     this.isMasked(control),
                        proto:      clone(control)
                    };

                    group.controls.push(control_)
                }
            }

            groups.push(group);
        }

        return groups;
    }

    updateGroups(props)  {
        this.groups = this.createGroups(props);
        this.setState({groups: clone(this.groups)});
    }

    updateMasked()  {
        this.groups.forEach(group => {
            group.masked = this.isMasked(group.proto);

            group.controls.forEach(control => {
                control.masked = this.isMasked(control.proto);
            });
        });

        this.setState({groups: clone(this.groups)});
    }

    updateLanguage()   {
        const si = this.oe.sharedInterface;
        const numLanguages = si.getUIControllerSettings().getNumLanguages();

        let languages = {};
        for(let i = 0; i < numLanguages; ++i)   {
            languages['lang_' + i.toString()] =  si.getLanguageTitleString({value: i});
        }

        this.setState({
            language:                                   si.getUIControllerSettings().getLanguage().value,
            switchPrimarySecondaryLanguage:             si.getUIControllerSettings().getSwitchPrimarySecondaryLanguage(),
            strings: {
                backgroundCategory:                     si.getLocalizedStringEnc('settings_view_background_header'),
                devCategory:                            si.getLocalizedStringEnc('settings_view_dev_header'),
                graphicsSettingsCategory:               si.getLocalizedStringEnc('settings_view_graphics_settings_header'),
                languageCategory:                       si.getLocalizedStringEnc('settings_view_lang_header'),
                touchSensitivityCategory:               si.getLocalizedStringEnc('settings_view_touch_sensitivity_header'),
                tutorCategory:                          si.getLocalizedStringEnc('settings_view_tutor_header'),
                uiCategory:                             si.getLocalizedStringEnc('settings_view_ui_header'),
                vpGizmoCategory:                        si.getLocalizedStringEnc('settings_view_vp_gizmo_header'),
                languageListBtn:                        si.getLocalizedStringEnc('settings_view_lang_label'),
                languageSwitchLabel:                    si.getLocalizedStringEnc('settings_view_primary_switch'),
                brightnessSliderLabel:                  si.getLocalizedStringEnc('settings_view_vignetting'),
                bgColorButtonLabel:                     si.getLocalizedStringEnc('settings_view_bg_color'),
                ambientOcclusionSwitchLabel:            si.getLocalizedStringEnc('settings_view_ambient_occlusion'),
                rendererPresetLabel:                    si.getLocalizedStringEnc('settings_view_renderer_preset'),
                languages:                              languages,
                uiLevelLabel:                           si.getLocalizedStringEnc('settings_view_ui_level'),
                uiLevels: {
                    std:                                si.getLocalizedStringEnc('settings_view_ui_level_std'),
                    simple:                             si.getLocalizedStringEnc('settings_view_ui_level_simple'),
                    advanced:                           si.getLocalizedStringEnc('settings_view_ui_level_advanced')
                },
                showComponentIDsLabel:                  si.getLocalizedStringEnc('settings_view_show_component_ids'),
                compHighlightingVPSwitchLabel:          si.getLocalizedStringEnc('settings_view_comp_highlighting_vp'),
                compHighlightingVPColorBtnLabel:        si.getLocalizedStringEnc('settings_view_comp_highlighting_vp_color'),
                compHighlightingLabelsSwitchLabel:      si.getLocalizedStringEnc('settings_view_comp_highlighting_labels'),
                tutorReset:                             si.getLocalizedStringEnc('settings_view_tutor_reset'),
            }
        });

        this.updateRendererPresets();
    }

    updateRendererPresets() {
        const si = this.oe.sharedInterface;
        var presets = si.getUIControllerSettings().getRendererPresetList();
        presets = presets.map(preset => { return {name: preset, label: si.getLocalizedStringEnc('settings_view_renderer_preset_' + preset)}; });
        this.setState({rendererPresets: presets});
    }

    updateControlsState()   {
        const settings = this.oe.sharedInterface.getUIControllerSettings();
        this.setState({
            brightness:                 settings.getVignetteStrength(),
            bgColor:                    settings.getBackgroundColor(),
            defaultBGColor:             settings.getDefaultBackgroundColor(),
            touchSensitivity:           settings.getTouchSensitivity(),
            ambientOcclusion:           settings.getAOQuality() > 0,
            activeRendererPreset:       settings.getRendererPreset(),
            uiLevel:                    UILevel.levelFromModuleValue(settings.getUILevel().value),
            showComponentIDs:           settings.getShowComponentIDs(),
            compHighlightingVP:         settings.getCompHighlightingVP(),
            compHighlightingVPColor:    settings.getCompHighlightingVPColor(),
            compHighlightingLabels:     settings.getCompHighlightingLabels()
        });
    }

    updateTutorState()  {
        this.setState({
            tutorIsClear: this.oe.sharedInterface.getUIControllerTutor().isClear()
        });
    }

    updateVPGizmoState()    {
        this.setState({
            vpGizmoDeactivated: this.oe.sharedInterface.getUIControllerVPGizmo().getDeactivated()
        });
    }

    updateUIState()   {
        this.setState({
            uiEnabled: this.oe.sharedInterface.getUIControllerSettings().getUIEnabled(),
            tutorUIEnabled: this.oe.sharedInterface.getUIControllerTutor().getUIEnabled()
        });
    }

    updateFeatureAccess()   {
        let featureSet = this.oe.sharedInterface.getUIControllerFeatureAccess().getFeatureSet();
        this.setState({
            featureAccess: {
                tooltip: featureSet.hasFeature({value: OEFeature.tooltip}),
                highlight: featureSet.hasFeature({value: OEFeature.highlight})
            }
        });
        featureSet.delete();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({uiEnabled: false});
            return;
        }

        retardUpdate(this, () => {
            this.setState({maxAOQuality: this.oe.sharedInterface.getUIControllerSettings().getMaxAOQuality()});

            let languages = this.oe.sharedInterface.getUIControllerSettings().getAvailableLanguages();
            languages = languages.map(lang => lang.value);
            this.setState({availableLanguages: languages});

            this.updateLanguage();
            
            this.updateControlsState();
            this.updateTutorState();
            this.updateVPGizmoState();
            this.updateUIState();
            this.updateFeatureAccess();
        });
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type !== this.oe.Module.UIControllerType.settings && userInfo.type !== this.oe.Module.UIControllerType.tutor) return;
        this.updateUIState();
    }

    onFeatureAccessChanged()    {
        this.updateFeatureAccess();
    }

    onLicensingAccess(licensingAccess)  {
        this.licensingAccess = licensingAccess;
        this.updateMasked();
    }

    onModelStateUpdateDriverRef(ref)    {
        this.modelStateUpdateDriver = ref;
        if(this.props.onModelStateUpdateDriverRef)  this.props.onModelStateUpdateDriverRef(ref);
    }

    getGroupPopoverTargetId(groupType)   {
        return 'settings-controller-' + groupType + '-popover-target';
    }

    renderControl(control, key, group)  {
        if(control.masked || (!this.props.devFeatures && control.proto.devFeature))    return null;

        const disabled = !(this.state.uiEnabled && control.enabled);
        const strings = this.state.strings;

        if(control.type === OESettingsControlType.language) {
            let entries = this.state.availableLanguages.map((lang) => { return {key: lang, content: <span className="label">{strings.languages['lang_' + lang.toString()]}</span>}; });
            let title = strings.languages['lang_' + this.state.language.toString()];

            return (
                <OEControl key={key}>
                    <OEDropdown
                        title={title}
                        disabled={disabled}
                        chosenKey={this.state.language}
                        entries={entries}
                        onClick={this.onLanguageSelected}
                    />
                </OEControl>
            );

        } else if(control.type === OESettingsControlType.languageSwitch) {

            return (
                <OEToggleCheckboxControl
                    className="align-right"
                    key={key}
                    title={strings.languageSwitchLabel}
                    active={this.state.switchPrimarySecondaryLanguage}
                    disabled={disabled}
                    onClick={this.onLanguageSwitchChanged}
                />
            );

        } else if(control.type === OESettingsControlType.vignette) {

            return (
                <OESliderControl
                    key={key}
                    title={strings.brightnessSliderLabel}
                    disabled={disabled}
                    min={0}
                    max={1}
                    step={0.005}
                    value={this.state.brightness}
                    onStart={this.onBrightnessSliderStart}
                    onSlide={this.onBrightnessSliderChanged}
                    onEnd={this.onBrightnessSliderEnd}
                />
            );

        } else if(control.type === OESettingsControlType.backgroundColor) {

            return (
                <OEColorPickerButtonControl
                    key={key}
                    moduleId={this.props.moduleId}
                    boundariesElement={this.props.boundariesElement}
                    target={this.getGroupPopoverTargetId(group.type)}
                    placement="right-start"
                    hideArrow={true}
                    title={strings.bgColorButtonLabel}
                    disabled={disabled}
                    color={this.state.bgColor}
                    defaultColor={this.state.defaultBGColor}
                    hasAlphaControl={false}
                    numericInput={this.props.devFeatures ? OEColorPickerNumericInputType.textField : OEColorPickerNumericInputType.rgbInput}
                    hasPaletteButton={this.props.devFeatures}
                    onChange={this.onBackgroundColorPickerChange}
                    onShow={this.onBackgroundColorPickerShow}
                    onHide={this.onBackgroundColorPickerHide}
                />
            );

        } else if(control.type === OESettingsControlType.vpGizmo) {

            return (
                <OEVPGizmoControllerControlPanel 
                    key={key}
                    moduleId={this.props.moduleId}
                    disabled={disabled}
                    alignmentControl={typeof(control.proto.data) === 'object' && typeof(control.proto.data.alignmentControl) === 'boolean' ? control.proto.data.alignmentControl : this.props.devFeatures}
                />
            );

        } else if(control.type === OESettingsControlType.touchSensitivity) {

            return (
                <OESliderControl
                    key={key}
                    disabled={disabled}
                    min={0.3}
                    max={1.3}
                    step={0.005}
                    value={this.state.touchSensitivity}
                    onSlide={this.onTouchSensitivitySliderChanged}
                />
            );

        } else if(control.type === OESettingsControlType.ambientOcclusion) {

            return (
                <OEToggleCheckboxControl
                    className="align-right"
                    key={key}
                    title={strings.ambientOcclusionSwitchLabel}
                    active={this.state.ambientOcclusion}
                    disabled={disabled || this.state.maxAOQuality == 0}
                    onClick={this.onAmbientOcclusionSwitchChanged}
                />
            );

        } else if(control.type === OESettingsControlType.rendererPreset) {

            if(this.state.rendererPresets.length < 2) return null;
            let activePreset = this.state.rendererPresets.find(preset => preset.name === this.state.activeRendererPreset);
            let title = this.state.strings.rendererPresetLabel;// + (activePreset ? ' - ' + activePreset.label : '');
            let entries = this.state.rendererPresets.map(preset => { return {key: preset.name, content: <span className="label">{preset.label}</span>}; });

            return (
                <OEControl key={key}>
                    <OEDropdown
                        title={title}
                        disabled={disabled}
                        chosenKey={this.state.activeRendererPreset}
                        entries={entries}
                        onClick={this.onPresetSelected}
                    />
                </OEControl>
            );

        } else if(control.type === OESettingsControlType.uiLevel) {

            let title = strings.uiLevels[this.state.uiLevel];
            let entries = control.proto.data ? control.proto.data : [UILevel.std];
            entries = entries.map((level) => { return {key: level, content: <span className="label">{strings.uiLevels[level]}</span>} } )

            return (
                <OEControl key={key}>
                    <OEDropdown
                        title={title}
                        disabled={disabled}
                        chosenKey={this.state.uiLevel}
                        entries={entries}
                        onClick={this.onUILevelSelected}
                    />
                </OEControl>
            );

        } else if(control.type === OESettingsControlType.showComponentIDs) {

            return (
                <OEToggleCheckboxControl
                    className="align-right"
                    key={key}
                    title={strings.showComponentIDsLabel}
                    active={this.state.showComponentIDs}
                    disabled={disabled}
                    onClick={this.onShowComponentIDsSwitchChanged}
                />
            );

        } else if(control.type === OESettingsControlType.compHighlightingVP) {

            return (
                <OEToggleCheckboxControl
                    className="align-right"
                    key={key}
                    title={strings.compHighlightingVPSwitchLabel}
                    active={this.state.compHighlightingVP}
                    disabled={disabled || !this.state.featureAccess.highlight}
                    onClick={this.onCompHighlightingVPSwitchChanged}
                />
            );

        } else if(control.type === OESettingsControlType.compHighlightingVPColor) {

            return (
                <OEColorPickerButtonControl
                    key={key}
                    moduleId={this.props.moduleId}
                    boundariesElement={this.props.boundariesElement}
                    target={this.getGroupPopoverTargetId(group.type)}
                    placement="right-start"
                    hideArrow={true}
                    title={strings.compHighlightingVPColorBtnLabel}
                    disabled={disabled || !this.state.featureAccess.highlight}
                    color={this.state.compHighlightingVPColor}
                    defaultColor={{x: 0, y: 1, z: 0, w: 1}}
                    hasAlphaControl={true}
                    alphaDisplayRange={{min: 0.5, max: 1/*, palette: {min: 1, max: 1}*/}}
                    numericInput={this.props.devFeatures ? OEColorPickerNumericInputType.textField : OEColorPickerNumericInputType.rgbInput}
                    hasPaletteButton={this.props.devFeatures}
                    onChange={this.onHighlightingVPColorBtnChanged}
                />
            );

        } else if(control.type === OESettingsControlType.compHighlightingLabels) {

            return (
                <OEToggleCheckboxControl
                    className="align-right"
                    key={key}
                    title={strings.compHighlightingLabelsSwitchLabel}
                    active={this.state.compHighlightingLabels}
                    disabled={disabled || !this.state.featureAccess.tooltip}
                    onClick={this.onCompHighlightingLabelsSwitchChanged}
                />
            );

        } else if(control.type === OESettingsControlType.tutorReset) {

            return (
                <OEControl key={key}>
                    <OEButton
                        disabled={disabled || !this.state.tutorUIEnabled || this.state.tutorIsClear}
                        className="btn"
                        onPressed={this.onTutorResetBtnPressed}
                    >
                        {strings.tutorReset}
                    </OEButton>
                </OEControl>
            );

        }

        return null;
    }

    renderGroup(group, key, separator)   {
        if(group.masked || (!this.props.devFeatures && group.proto.devFeature))    return null;

        if(this.state.vpGizmoDeactivated && group.type === OESettingsControlGroupType.vpGizmo)  return null;

        //
        const controls = group.controls.map((control, index) => this.renderControl(control, index, {type: group.type, title: title})).filter(control => control != null);
        if(!controls.length)    return null;

        //
        const strings = this.state.strings;

        let title = '';
        switch(group.type)  {
            case OESettingsControlGroupType.background:         title = strings.backgroundCategory; break;
            case OESettingsControlGroupType.dev:                title = strings.devCategory; break;
            case OESettingsControlGroupType.graphics:           title = strings.graphicsSettingsCategory; break;
            case OESettingsControlGroupType.inputSensitivity:   title = strings.touchSensitivityCategory; break;
            case OESettingsControlGroupType.language:           title = strings.languageCategory; break;
            case OESettingsControlGroupType.tutor:              title = strings.tutorCategory; break;
            case OESettingsControlGroupType.ui:                 title = strings.uiCategory; break;
            case OESettingsControlGroupType.vpGizmo:            title = strings.vpGizmoCategory; break;
        }

        //
        return (
            <OEGroupControl key={key} title={title} separator={separator} popoverTargetId={this.getGroupPopoverTargetId(group.type)}>
                {controls}
            </OEGroupControl>
        );
    }

    render() {
        if(!this.props.config.enabled) return null;
        
        const groups = this.state.groups.map((group, index) => this.renderGroup(group, index, this.state.groups.length > index + 1)).filter(group => group != null);

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>
                <OEModelStateUpdateEnabledStateDriver moduleId={this.props.moduleId} ref={this.onModelStateUpdateDriverRef}/>

                <OEMultiColumnContainer className="settings-controller">{groups}</OEMultiColumnContainer>
            </React.Fragment>
        );
    }

    onLanguageSelected(key) {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setLanguage({value: key});
    }

    onLanguageSwitchChanged()   {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setSwitchPrimarySecondaryLanguage(!this.state.switchPrimarySecondaryLanguage);
    }

    onBrightnessSliderStart(sender, value) {
        if(this.modelStateUpdateDriver) this.modelStateUpdateDriver.inc();
    }

    onBrightnessSliderEnd(sender, value) {
        if(this.modelStateUpdateDriver) this.modelStateUpdateDriver.dec();
    }
    
    onBrightnessSliderChanged(sender, value)    {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setVignetteStrength(value);
    }

    onBackgroundColorPickerShow(id, color)    {
        if(this.modelStateUpdateDriver) this.modelStateUpdateDriver.inc();
    }

    onBackgroundColorPickerHide(id, color)    {
        if(this.modelStateUpdateDriver) this.modelStateUpdateDriver.dec();
    }

    onBackgroundColorPickerChange(sender, color)  {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setBackgroundColor(color);
    }
    
    onTouchSensitivitySliderChanged(sender, value)  {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setTouchSensitivity(value);
    }
    
    onAmbientOcclusionSwitchChanged()   {
        if(!this.oe.isReady()) return;
        let max = this.oe.sharedInterface.getUIControllerSettings().getMaxAOQuality();
        this.oe.sharedInterface.getUIControllerSettings().setAOQuality(!this.state.ambientOcclusion ? max : 0);
    }

    onPresetSelected(key)   {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setRendererPreset(key);
    }

    onUILevelSelected(key)  {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setUILevel({value: UILevel.moduleValueFromLevel(key)});
    }

    onShowComponentIDsSwitchChanged(key)    {
        if(!this.oe.isReady()) return;
        let showing = this.oe.sharedInterface.getUIControllerSettings().getShowComponentIDs();
        this.oe.sharedInterface.getUIControllerSettings().setShowComponentIDs(!showing);
    }

    onCompHighlightingVPSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setCompHighlightingVP(!this.state.compHighlightingVP);
    }

    onHighlightingVPColorBtnChanged(sender, color)   {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setCompHighlightingVPColor(color);
    }

    onCompHighlightingLabelsSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerSettings().setCompHighlightingLabels(!this.state.compHighlightingLabels);
    }

    onTutorResetBtnPressed()    {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerTutor().reset();
    }
}

OESettingsController.defaultProps = OESettingsControllerProps.controllerDefaultProps;

OESettingsController.propTypes = OESettingsControllerProps.controller;

export default withUILevel(OESettingsController);